import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const TastyBites = ({ cart, setCart, isCartOpen, setIsCartOpen }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  // REMOVE THIS LINE: const [cart, setCart] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All Items");

  useEffect(() => {
    // Check if user is logged in
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  // Menu items data
  const menuItems = [
    {
      id: 1,
      name: "Creamy Pasta",
      description: "Delicious pasta in creamy white sauce with fresh herbs",
      price: 12.99,
      type: "vegetarian",
      category: "Appetizers",
      image:
        "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 2,
      name: "Classic Burger",
      description: "Juicy beef patty with fresh vegetables and special sauce",
      price: 9.99,
      type: "non_vegetarian",
      category: "Appetizers",
      image:
        "https://images.unsplash.com/photo-1563379926898-05f4575a45d8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 3,
      name: "Margherita Pizza",
      description: "Classic pizza with tomato sauce, mozzarella, and basil",
      price: 14.99,
      type: "eggetarian",
      category: "Main Course",
      image:
        "https://images.unsplash.com/photo-1513104890138-7c749659a591?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 4,
      name: "Fresh Garden Salad",
      description: "Mixed greens with vegetables and house dressing",
      price: 8.99,
      type: "vegetarian",
      category: "Main Course",
      image:
        "https://png.pngtree.com/thumb_back/fw800/background/20250919/pngtree-a-gourmet-greek-salad-placed-on-stylish-restaurant-table-image_19505914.webp",
    },
  ];

  // Categories for filtering
  const categories = [
    "All Items",
    "Main Course",
    "Appetizers",
    "Beverages",
    "Desserts",
    "Vegetarian",
    "Chinese",
    "Juices",
  ];

  // Add item to cart
  const addToCart = (item) => {
    const existingItem = cart.find((cartItem) => cartItem.id === item.id);

    if (existingItem) {
      setCart(
        cart.map((cartItem) =>
          cartItem.id === item.id
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        )
      );
    } else {
      setCart([...cart, { ...item, quantity: 1 }]);
    }

    // Show the cart when adding an item
    setIsCartOpen(true);
  };

  // Increment item quantity
  const incrementItem = (id) => {
    setCart(
      cart.map((item) =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  // Decrement item quantity
  const decrementItem = (id) => {
    const item = cart.find((item) => item.id === id);

    if (item.quantity === 1) {
      removeFromCart(id);
    } else {
      setCart(
        cart.map((item) =>
          item.id === id ? { ...item, quantity: item.quantity - 1 } : item
        )
      );
    }
  };

  // Remove item from cart
  const removeFromCart = (id) => {
    setCart(cart.filter((item) => item.id !== id));
  };

  // Calculate cart totals
  const calculateTotals = () => {
    const subtotal = cart.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
    const tax = subtotal * 0.1;
    const total = subtotal + tax;

    return {
      subtotal: subtotal.toFixed(2),
      tax: tax.toFixed(2),
      total: total.toFixed(2),
    };
  };

  // Place order
  const placeOrder = () => {
    if (cart.length === 0) return;

    alert("Order placed successfully! It has been sent to the kitchen.");
    setCart([]);
    setIsCartOpen(false);
  };

  // Get total items in cart
  const getTotalItems = () => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  };

  // Get quantity for a specific item
  const getItemQuantity = (id) => {
    const item = cart.find((item) => item.id === id);
    return item ? item.quantity : 0;
  };

  // Render food type indicator
  const renderFoodTypeIndicator = (type) => {
    let className = "veg-indicator ";

    switch (type) {
      case "vegetarian":
        className += "veg";
        break;
      case "non_vegetarian":
        className += "non-veg";
        break;
      case "eggetarian":
        className += "eggetarian";
        break;
      default:
        className += "veg";
    }

    return <span className={className} title={type.replace("_", " ")}></span>;
  };

  // Filter menu items by category
  const filteredMenuItems =
    activeCategory === "All Items"
      ? menuItems
      : menuItems.filter(
          (item) =>
            item.category === activeCategory ||
            item.type.replace("_", " ") === activeCategory
        );

  // Group menu items by category
  const menuItemsByCategory = filteredMenuItems.reduce((groups, item) => {
    if (!groups[item.category]) {
      groups[item.category] = [];
    }
    groups[item.category].push(item);
    return groups;
  }, {});

  return (
    <div className={`tasty-bites-app ${isCartOpen ? "cart-open" : ""}`}>
      {/* Toast Container */}
      <div className="toast-container"></div>

      {/* Cart Overlay */}
      {isCartOpen && (
        <div
          className="cart-overlay"
          onClick={() => setIsCartOpen(false)}
        ></div>
      )}

      {/* Category Navigation */}
      <div className="category-nav py-2">
        <div className="container">
          <div className="d-flex category-scroll">
            {categories.map((category) => (
              <button
                key={category}
                className={`btn btn-outline-secondary category-btn ${
                  activeCategory === category ? "active" : ""
                }`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mt-4">
        {/* Responsive Banner */}
        <div className="banner rounded-3">
          <div className="banner-content">
            <h1>Welcome to TastyBites Restaurant</h1>
            <p>
              Experience the finest cuisine with our specially crafted menu.
              Order directly from your table and enjoy freshly prepared meals.
            </p>
            <button className="btn banner-btn">
              <i className="fas fa-star me-2"></i>Today's Special
            </button>
          </div>
        </div>

        <div className="row">
          {/* Menu Items */}
          <div className="col-lg-8">
            {Object.keys(menuItemsByCategory).map((category) => (
              <div key={category} className="menu-section">
                <h3 className="section-title">{category}</h3>
                <div className="row">
                  {menuItemsByCategory[category].map((item) => {
                    const quantity = getItemQuantity(item.id);

                    return (
                      <div key={item.id} className="col-md-6 mb-4">
                        <div className="card menu-item-card">
                          <div className="position-relative">
                            <img
                              src={item.image}
                              className="card-img-top menu-item-image"
                              alt={item.name}
                            />
                            <span className="position-absolute top-0 end-0 food-type-badge">
                              {renderFoodTypeIndicator(item.type)}
                            </span>
                          </div>
                          <div className="card-body">
                            <h5 className="card-title">{item.name}</h5>
                            <p className="card-text">{item.description}</p>
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="h5 mb-0">
                                ${item.price.toFixed(2)}
                              </span>
                              <div className="quantity-controls">
                                {quantity > 0 ? (
                                  <>
                                    <button
                                      className="btn btn-sm btn-outline-secondary quantity-btn"
                                      onClick={() => decrementItem(item.id)}
                                    >
                                      <i className="fas fa-minus"></i>
                                    </button>
                                    <span className="quantity-display">
                                      {quantity}
                                    </span>
                                    <button
                                      className="btn btn-sm btn-outline-primary quantity-btn"
                                      onClick={() => incrementItem(item.id)}
                                    >
                                      <i className="fas fa-plus"></i>
                                    </button>
                                  </>
                                ) : (
                                  <button
                                    className="btn btn-primary add-btn"
                                    onClick={() => addToCart(item)}
                                  >
                                    <i className="fas fa-plus me-1"></i> Add
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          {/* Table Info & Instructions */}
          <div className="col-lg-4">
            <div className="sticky-top" style={{ top: "112px", zIndex: 1010 }}>
              <div className="table-info mb-4">
                <h5>
                  <i className="fas fa-table me-2"></i>Table Information
                </h5>
                <p className="mb-1">
                  <strong>Table #:</strong> 12
                </p>
                <p className="mb-1">
                  <strong>Guests:</strong> 4
                </p>
                <p className="mb-0">
                  <strong>Server:</strong> Michael
                </p>
              </div>

              <div className="card mb-4">
                <div className="card-body">
                  <h5 className="card-title">Special Instructions</h5>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Any special requests for your order..."
                  ></textarea>
                </div>
              </div>

              <div className="d-grid">
                <button className="btn btn-success btn-lg" onClick={placeOrder}>
                  <i className="fas fa-paper-plane me-2"></i>Place Order
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Cart Sidebar */}
      <div className={`cart-sidebar ${isCartOpen ? "" : "cart-hidden"}`}>
        <div className="p-3 border-bottom">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Your Order</h5>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => setIsCartOpen(false)}
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div className="p-3">
          <div className="cart-items">
            {cart.length === 0 ? (
              <p className="text-center text-muted py-3">Your cart is empty</p>
            ) : (
              cart.map((item) => (
                <div key={item.id} className="cart-item">
                  <div className="d-flex justify-content-between">
                    <div>
                      <h6 className="mb-0">{item.name}</h6>
                      <small className="text-muted">
                        ${item.price.toFixed(2)} × {item.quantity}
                      </small>
                      <div className="cart-quantity-controls">
                        <button
                          className="btn btn-sm btn-outline-secondary cart-quantity-btn"
                          onClick={() => decrementItem(item.id)}
                        >
                          <i className="fas fa-minus"></i>
                        </button>
                        <span className="cart-quantity-display">
                          {item.quantity}
                        </span>
                        <button
                          className="btn btn-sm btn-outline-primary cart-quantity-btn"
                          onClick={() => incrementItem(item.id)}
                        >
                          <i className="fas fa-plus"></i>
                        </button>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="me-2">
                        ${(item.price * item.quantity).toFixed(2)}
                      </span>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => removeFromCart(item.id)}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {cart.length > 0 && (
            <div className="mt-3 pt-3 border-top">
              <div className="d-flex justify-content-between mb-2">
                <span>Subtotal:</span>
                <span>${calculateTotals().subtotal}</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span>Tax (10%):</span>
                <span>${calculateTotals().tax}</span>
              </div>
              <div className="d-flex justify-content-between mb-3">
                <strong>Total:</strong>
                <strong>${calculateTotals().total}</strong>
              </div>

              <div className="d-grid">
                <button className="btn btn-primary" onClick={placeOrder}>
                  <i className="fas fa-check me-1"></i>Proceed to Checkout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Cart Bar */}
      <div className="mobile-cart-bar">
        <div className="d-flex align-items-center">
          <span className="me-2">
            <i className="fas fa-shopping-cart"></i>
          </span>
          <span>
            {getTotalItems()} {getTotalItems() === 1 ? "Item" : "Items"}
          </span>
        </div>
        <div>
          <span className="me-3">${calculateTotals().subtotal}</span>
          <button
            className="btn btn-primary btn-sm"
            onClick={() => setIsCartOpen(true)}
          >
            View Cart
          </button>
        </div>
      </div>

      <style jsx>{`
        :root {
          --primary: #2c3e50;
          --secondary: #e74c3c;
          --accent: #3498db;
          --light: #ecf0f1;
          --dark: #2c3e50;
          --success: #27ae60;
        }

        body {
          background-color: #f8f9fa;
          font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
          padding-top: 112px;
          padding-bottom: 70px;
        }

        .navbar {
          background-color: var(--primary);
          position: fixed;
          top: 0;
          width: 100%;
          z-index: 1030;
        }

        .category-nav {
          background-color: white;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          position: fixed;
          top: 56px;
          width: 100%;
          z-index: 1020;
        }

        .banner {
          background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
            url("https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1200&q=80");
          background-size: cover;
          background-position: center;
          color: white;
          padding: 40px 0;
          margin-bottom: 30px;
          text-align: center;
        }

        .banner-content {
          max-width: 800px;
          margin: 0 auto;
          padding: 0 15px;
        }

        .banner h1 {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 15px;
        }

        .banner p {
          font-size: 1.2rem;
          margin-bottom: 20px;
        }

        .banner-btn {
          background-color: var(--secondary);
          border: none;
          padding: 12px 30px;
          font-size: 1.1rem;
          border-radius: 30px;
          transition: all 0.3s;
        }

        .banner-btn:hover {
          background-color: #c0392b;
          transform: translateY(-2px);
        }

        @media (max-width: 768px) {
          .banner {
            padding: 30px 0;
          }

          .banner h1 {
            font-size: 2rem;
          }

          .banner p {
            font-size: 1rem;
          }

          .banner-btn {
            padding: 10px 25px;
            font-size: 1rem;
          }
        }

        @media (max-width: 576px) {
          .banner {
            padding: 20px 0;
          }

          .banner h1 {
            font-size: 1.7rem;
          }

          .banner p {
            font-size: 0.9rem;
          }
        }

        .category-btn {
          transition: all 0.3s;
          border-radius: 20px;
          margin: 0 5px;
          white-space: nowrap;
        }

        .category-btn:hover,
        .category-btn.active {
          background-color: var(--secondary);
          color: white;
        }

        .menu-item-card {
          transition: transform 0.3s, box-shadow 0.3s;
          border: none;
          border-radius: 10px;
          overflow: hidden;
          height: 100%;
        }

        .menu-item-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }

        .menu-item-image {
          height: 180px;
          object-fit: cover;
        }

        .veg-indicator {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          display: inline-block;
        }

        .veg {
          background-color: green;
          border: 1px solid green;
        }

        .non-veg {
          background-color: var(--secondary);
          border: 1px solid var(--secondary);
        }

        .eggetarian {
          background-color: #ff9800;
          border: 1px solid #ff9800;
        }

        .cart-sidebar {
          background-color: white;
          border-left: 1px solid #dee2e6;
          height: calc(100vh - 56px);
          position: fixed;
          top: 56px;
          right: 0;
          width: 350px;
          overflow-y: auto;
          transition: transform 0.3s ease-in-out;
          z-index: 1040;
          box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
        }

        .cart-hidden {
          transform: translateX(100%);
        }

        .cart-item {
          border-bottom: 1px solid #eee;
          padding: 10px 0;
        }

        .cart-badge {
          position: absolute;
          top: -5px;
          right: -5px;
          background-color: var(--secondary);
          color: white;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          z-index: 1;
        }

        .quantity-btn {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          font-size: 14px;
        }

        .food-type-badge {
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 1;
        }

        @media (max-width: 768px) {
          body {
            padding-top: 104px;
            padding-bottom: 70px;
          }

          .category-nav {
            top: 56px;
          }

          .cart-sidebar {
            width: 100%;
            z-index: 1040;
          }

          .category-scroll {
            overflow-x: auto;
            flex-wrap: nowrap;
            padding-bottom: 10px;
          }

          .category-btn {
            margin: 0 3px;
            font-size: 0.9rem;
          }
        }

        .table-info {
          background-color: var(--light);
          border-radius: 10px;
          padding: 15px;
        }

        .special-instructions {
          font-size: 0.85rem;
          color: #6c757d;
        }

        .menu-section {
          margin-top: 20px;
        }

        .section-title {
          position: relative;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 2px solid #eee;
        }

        .section-title::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 60px;
          height: 2px;
          background-color: var(--secondary);
        }

        .cart-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 1035;
        }

        .mobile-cart-bar {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          background: white;
          box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
          padding: 10px 15px;
          z-index: 1030;
          display: none;
        }

        @media (max-width: 768px) {
          .mobile-cart-bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }

        .toast-container {
          position: fixed;
          top: 120px;
          right: 20px;
          z-index: 1050;
        }

        .quantity-controls {
          display: flex;
          align-items: center;
        }

        .quantity-display {
          margin: 0 10px;
          font-weight: bold;
          min-width: 30px;
          text-align: center;
        }

        .cart-quantity-controls {
          display: flex;
          align-items: center;
          margin-top: 5px;
        }

        .cart-quantity-btn {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          font-size: 12px;
        }

        .cart-quantity-display {
          margin: 0 8px;
          font-weight: bold;
          min-width: 20px;
          text-align: center;
        }

        .add-btn {
          min-width: 90px;
        }
      `}</style>
    </div>
  );
};

export default TastyBites;
